import Service from "./abstract/Service";

export default class LocationService extends Service {

  findByZipCodeAndHouseNumber(zipCode, houseNumber, countryId) {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + '/location/find-address', {
        params: {
          zip_code: zipCode,
          house_number: houseNumber,
          country_id: countryId
        }
      }).then(data => {
        resolve(data);
      }).catch((e) => reject(e.response));
    });
  }

  findByAddress(zipCode, houseNumber, countryId, street, city) {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + '/location/find-coordinates', {
        params: {
          zip_code: zipCode,
          house_number: houseNumber,
          country_id: countryId,
          street: street,
          city: city
        }
      }).then(data => {
        resolve(data);
      }).catch((e) => reject(e.response));
    });
  }
}
